<textarea
    [class.no-resize]="!resize"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.readonly]="readOnly"
    [required]="isRequired"
    [rows]="rows"
    [value]="value"
    (input)="valueChange.emit($event.target.value)"
></textarea>
